module.exports = __webpack_public_path__ + "img/图形验证码.330930d5.png";